/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import {
	InnerBlocks,
	store as blockEditorStore,
} from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { updateBlockStyle } from './inline-styles';

const Edit = ( props ) => {
	const { className, isSelected, clientId } = props;

	const { hasInnerBlocks } = useSelect(
		( select ) => {
			const { getBlock } = select( blockEditorStore );
			const block = getBlock( clientId );
			return {
				hasInnerBlocks: !! ( block && block.innerBlocks.length ),
			};
		},
		[ clientId ]
	);

	const updateBlock = ( data ) => {
		const { setAttributes } = props;
		setAttributes( {
			...data,
		} );

		updateBlockStyle( data, props );
	};

	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );

	const wrapperClasses = classnames(
		className,
		`gutenify-block-container-wrapper`,
	);
	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } updateBlock={ updateBlock } /> }
		<div className="gutenify-container">
			<InnerBlocks
				renderAppender={ hasInnerBlocks ? false : () => (
					<InnerBlocks.ButtonBlockAppender />
				) }
			/>
		</div>
	</div>;
};

export default Edit;
